export enum ExportStatus {
  Created = 'CREATED',
  Exporting = 'EXPORTING',
  ExportingManually = 'EXPORTING_MANUALLY',
  ExportNeedsReview = 'EXPORT_NEEDS_REVIEW',
  ExportedSuccessfully = 'EXPORTED_SUCCESSFULLY',
  ExportedManually = 'EXPORTED_MANUALLY',
}

export enum ExtractStatus {
  Created = 'CREATED',
  Extracting = 'EXTRACTING',
  ExtractingManually = 'EXTRACTING_MANUALLY',
  ExtractNeedsReview = 'EXTRACT_NEEDS_REVIEW',
  ExtractedSuccessfully = 'EXTRACTED_SUCCESSFULLY',
  ExtractedManually = 'EXTRACTED_MANUALLY',
}
